/**
 * 二维码页懒加载壳（14.32；MyAppearanceLazy 同构）：低频页不进首屏 bundle，
 * uqr 编码器也随本 chunk 之后按需加载。groupId 缺省=我的二维码。
 */
import { useLazyModule } from './useLazyModule';

export function QrCodeLazy({ groupId }: { groupId?: number }) {
  const { mod } = useLazyModule(() => import('./QrCodePage'));
  if (mod === null) return <div data-testid="qr-loading-shell">加载中…</div>;
  return groupId === undefined ? <mod.QrCodePage /> : <mod.QrCodePage groupId={groupId} />;
}
